import { Component } from '@angular/core';

@Component({
  selector: 'app-email-content-tutorial',
  templateUrl: './email-content-tutorial.component.html',
  styleUrls: ['./email-content-tutorial.component.scss']
})
export class EmailContentTutorialComponent {
  public htmlCode = `<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <title>Félicitations !</title>
</head>
<body style="font-family: Arial, sans-serif; color: #333333; line-height: 1.6;">

  <div style="text-align: center;">
    <img src="[Logo_Boutique]" alt="Logo Boutique" style="max-width: 200px;" />
  </div>

  <div style="text-align: center; margin: 20px 0;">
    <img src="[Image_Entête]" alt="Image Entête" style="width: 100%; max-width: 600px;" />
  </div>

  <p>Bonjour <strong>[QUESTION-0]</strong>,</p>

  <h2 style="color: #4CAF50;">🎁 Félicitations !</h2>

  <p>Grâce à ton achat réalisé en magasin, tu as gagné <strong>[PRIZE]</strong>.</p>

  <p>Va le récupérer à l'accueil avec ce mail.</p>

  <p>Cordialement.</p>

  <div style="text-align: center; margin-top: 30px;">
    <img src="[Image_Pied-de-mail]" alt="Pied de mail" style="width: 100%; max-width: 600px;" />
  </div>

</body>
</html>`
}
